<template>
  <v-row
    class="field-indent"
    :class="{'flex-nowrap flex-row-reverse mt-2 mb-4 ': boolHasDefinedTitle}"
  >
    <div
      v-if="description"
      v-html="description"
      :class="[
        'description', { 'align-self-center': boolHasDefinedTitle }
      ]"
    >
    </div>
    <ValidationProvider :name="field.name | slugify" slim :rules="rules">
      <v-switch
        :label="boolHasDefinedTitle ? '' : `${field.name} ${requiredHint}`"
        :class="{'mr-7': boolHasDefinedTitle}"
        :input-value="field.defaultValue"
        v-model="value"
      ></v-switch>
    </ValidationProvider>
  </v-row>
</template>

<script>
  import _ from 'lodash'

  export default {
    name: 'SwitchField',
    props: ['field', 'boolHasDefinedTitle'],
    data() {
      return {
        value: false
      }
    },
    mounted() {
      this.value = this.field.defaultValue;
      this.setValue(this.value);
    },
    computed: {
      rules() {
        return this.field.required ? 'requiredSwitch' : '';
      },
      requiredHint() {
        return this.field.required ? ' *' : '';
      },
      description() {
        const fieldDescription =
          _.get(this.field, 'metadata.description', '') || _.get(this.field, 'description', '')

        if (!_.isEmpty(fieldDescription)) {
          return fieldDescription
        }

        return ''
      },
    },
    watch: {
      value(newVal) {
        this.setValue(newVal);
      },
    },
    methods: {
      setValue(value) {
        this.$emit("switch", {
          key: this.field.key,
          value: value,
          identity: this.field.identity ? this.field.identity : false
        });
      }
    },
  }
</script>

<style>

</style>
